import * as req from 'api/actions';
import * as c from './constant';

export const getTransactionList = (payload, callback) =>
  req.list(
    c.GET_TRANSACTION,
    'api/v1/administrators/wallet/cash_transfer',
    payload,
    callback
  );

export const showTransaction = (id, payload, callback) =>
  req.item(
    c.SHOW_TRANSACTION,
    `api/v1/administrators/wallet/cash_transfer/${id}`,
    payload,
    callback
  );
